function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback } from 'react';
import './CopyButton.css';
import Button from '../Buttons/Button/Button';
//MutableRefObject<HTMLElement | null>
/**
 * Button that copies `contentToCopy` to clipboard
 */
function BaseCopyButton(_ref, ref) {
  var contentToCopy = _ref.contentToCopy,
    children = _ref.children,
    attrs = _objectWithoutProperties(_ref, ["contentToCopy", "children"]);
  var copyToClipboard = useCallback(function (event) {
    var activeEl = document.activeElement ? document.activeElement : event.target;
    var txtField = document.createElement('textarea');
    txtField.value = contentToCopy;
    document.body.appendChild(txtField);
    txtField.select();
    document.execCommand('copy');
    txtField.remove();
    activeEl.focus();
  }, [contentToCopy]);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    ref: ref,
    onClick: copyToClipboard,
    modifier: "copy",
    wrap: false
  }, attrs), children);
}
var Component = React.forwardRef(BaseCopyButton);
Component.displayName = 'CopyButton';
export default Component;